import { ENDPOINTS, METHODS } from "@/constants/apiConstants";
import { apiSlice } from "../baseApi";

const teamsBaseEndpoint = ENDPOINTS.TEAMS;

// Teams API
export const teamsApi = apiSlice
  .enhanceEndpoints({
    addTagTypes: ["teams"],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getTeams: builder.query({
        query: (payload) => `${teamsBaseEndpoint}`,
        transformResponse: (response) => response.data,
        providesTags: () => [{ type: "teams" }],
        // keepUnusedDataFor: 0, // Set to 0 seconds to always fetch fresh data
      }),
      
      addTeams: builder.mutation({
        query: (requestData) => ({
          url: `${teamsBaseEndpoint}`,
          method: METHODS.POST,
          body: requestData,
        }),
        invalidatesTags: () => [{ type: "teams" }],
      }),
      updateTeam: builder.mutation({
        query: ({id,requestData}) => ({
          url: `${teamsBaseEndpoint}${id}`,
          method: METHODS.PUT,
          body: requestData,
        }),
        invalidatesTags: () => [{ type: "teams" }],
      }),
      deleteTeam: builder.mutation({
        query: (id) => ({
          url: `${teamsBaseEndpoint}${id}`,
          method: METHODS.DELETE,
        }),
        invalidatesTags: () => [{ type: "teams" }],
      }),
    }),
  });

// Export hooks for usage in components

export const { useGetTeamsQuery, useAddTeamsMutation, useUpdateTeamMutation, useDeleteTeamMutation } = teamsApi;
